// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Date from "@artegeie/date";

function makeDateWithoutTime(refDate) {
  var date = refDate.getDate();
  var year = refDate.getFullYear();
  var month = refDate.getMonth();
  return new Date(year, month, date);
}

function makeDateFromTimeInterval(date, timeInterval) {
  var end = timeInterval.end;
  var start = timeInterval.start;
  var startDate = makeDateWithoutTime(date);
  startDate.setHours(start.hour, start.minute);
  var endDate = makeDateWithoutTime(date);
  endDate.setHours(end.hour, end.minute);
  return {
          start: startDate,
          end: endDate
        };
}

function compareDayPeriod(upcomingDate, dayPeriod) {
  var morningInterval = makeDateFromTimeInterval(upcomingDate, dayPeriod.morning);
  var dayTimeInterval = makeDateFromTimeInterval(upcomingDate, dayPeriod.dayTime);
  var eveningInterval = makeDateFromTimeInterval(upcomingDate, dayPeriod.evening);
  if ($$Date.isWithinInterval(upcomingDate, morningInterval)) {
    return /* Morning */0;
  } else if ($$Date.isWithinInterval(upcomingDate, dayTimeInterval)) {
    return /* DayTime */1;
  } else {
    $$Date.isWithinInterval(upcomingDate, eveningInterval);
    return /* Evening */2;
  }
}

var frDayPeriod = {
  morning: {
    start: {
      hour: 5,
      minute: 0
    },
    end: {
      hour: 12,
      minute: 59
    }
  },
  dayTime: {
    start: {
      hour: 13,
      minute: 0
    },
    end: {
      hour: 20,
      minute: 49
    }
  },
  evening: {
    start: {
      hour: 20,
      minute: 50
    },
    end: {
      hour: 23,
      minute: 59
    }
  }
};

var deDayPeriod = {
  morning: {
    start: {
      hour: 5,
      minute: 0
    },
    end: {
      hour: 12,
      minute: 59
    }
  },
  dayTime: {
    start: {
      hour: 13,
      minute: 0
    },
    end: {
      hour: 20,
      minute: 14
    }
  },
  evening: {
    start: {
      hour: 20,
      minute: 15
    },
    end: {
      hour: 23,
      minute: 59
    }
  }
};

export {
  frDayPeriod ,
  deDayPeriod ,
  makeDateWithoutTime ,
  makeDateFromTimeInterval ,
  compareDayPeriod ,
}
/* @artegeie/date Not a pure module */
